import { createResource, deleteResource } from "./api";

// Signs a scoped feed-post video upload (folder, authenticated delivery, allowed formats). Passed to
// uploadVideoToCloudinary as its `sign` fn so the browser uploads straight to Cloudinary. Behind
// FEED_POST_VIDEO_UPLOAD_ENABLED server-side (404 when off). Twin of messages.signVideoUpload.
export const signVideoUpload = async () => createResource("/interact/api/feed_posting/video_signature", {});

// Maps a composer attachment to the server's permitted shape, dropping client-only fields (localUrl).
// A video ref carries public_id/resource_type; an image carries a base64 file_cloudinary data-URI.
const toAttachmentParam = (a) => {
  if (a.resource_type === "video" && a.public_id) {
    return {
      public_id: a.public_id,
      resource_type: a.resource_type,
      format: a.format,
      duration: a.duration,
      bytes: a.bytes,
      filename: a.filename,
      recorded: a.recorded,
    };
  }
  return { file_cloudinary: a.file_cloudinary, filename: a.filename };
};

// Feed-post writes go through the Rails endpoint (JSON:API envelope);
// createResource/deleteResource inject auth + token refresh. Reads come from the
// feed RPC (see profile_feeds.js), not from here.
//
// The attributes mirror Interact::Api::FeedPostsController's permitted params:
// kind, body, work_url/title/outlet, credited_entity_ids[], attachments[].
const create = async ({
  kind,
  body = null,
  workUrl = null,
  workTitle = null,
  workOutlet = null,
  creditedEntityIds = [],
  attachments = [],
}) => {
  const attributes = { kind };
  if (body != null) attributes.body = body;
  if (workUrl != null) attributes.work_url = workUrl;
  if (workTitle != null) attributes.work_title = workTitle;
  if (workOutlet != null) attributes.work_outlet = workOutlet;
  if (creditedEntityIds.length) attributes.credited_entity_ids = creditedEntityIds.map(String);
  if (attachments.length) attributes.attachments = attachments.map(toAttachmentParam);

  return createResource("/interact/api/feed_posts", { data: { attributes } });
};

const destroy = async (id) => deleteResource(`/interact/api/feed_posts/${id}`);

export default { create, destroy, signVideoUpload };
